<template>
<div :class="['calc-input', {'calc-input__styled': styled}]">
  <button
    class="calc-input_minus"
    @click="minus"
  >
    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 1L-1.78814e-07 0.999999" stroke="#999999" stroke-width="2"/>
    </svg>
  </button>
  <div class="calc-input_text">
    <input
      type="number"
      class="calc-input_field"
      :value="money"
      @input="moneyChange"
      v-autowidth="{maxWidth: '185px', minWidth: '50%', comfortZone: 0}"
    />
    <span class="calc-input_units"><slot name="units" /></span>
  </div>
  <button
    class="calc-input_plus"
    @click="plus"
  >
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 7V12H7.5V7H12.5V5H7.5V0H5.5V5H0.5V7H5.5Z" fill="#999999"/>
    </svg>
  </button>
</div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
class ExtraBonusCalcInput extends Vue {
  @Prop({
    type: Number,
    required: true
  }) money

  @Prop({
    type: Boolean,
    default: false
  }) styled

  moneyChange (e) {
    const { target } = e
    let money = Math.min(500000, target.value)
    if (target.value < 1) money = 1
    target.value = money
    this.$emit('update:money', money)
  }

  minus () {
    this.$emit('update:money', this.money - 100)
  }

  plus () {
    this.$emit('update:money', this.money + 100)
  }
}
export default ExtraBonusCalcInput
</script>

<style lang="scss">
.calc-input {
  display: flex;
  border: 1px solid #666666;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 8px;
  @include media_tablet {
    width: calc(50% - 12px);
    margin-bottom: 0;
  }
  &__styled {
    border-color: var(--selected-game-color);
  }

  &_text {
    flex: 1;
    height: 40px;
    display: flex;
    padding: 0 16px;
  }
  &_field {
    height: 100%;
    padding: 0;
    margin: 0;
    border: 0;
    background: none;
    line-height: 40px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
    text-align: right;
    padding-right: 8px;
  }
  &_units {
    line-height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    color: #FFFFFF;
    > span {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    svg path {
      fill: var(--selected-game-color);
    }
  }
  &_minus,
  &_plus{
    background: none;
    border: none;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    > svg {
      transition: filter .3s ease;
    }
    svg path {
      transition: fill .3s ease, stroke .3s ease;
    }
  }
  &_minus {
    border-right: 1px solid #666666;
    &:hover {
      svg {
        filter: drop-shadow(0 0 5px #ffffff);
        .calc-input__styled & {
          filter: drop-shadow(0 0 5px var(--selected-game-color));
        }
      }
    }
    .calc-input__styled & {
      border-color: var(--selected-game-color);
    }
    svg path {
      .calc-input__styled & {
        stroke: var(--selected-game-color);
      }
    }
  }
  &_plus {
    border-left: 1px solid #666666;
    &:hover {
      svg {
        filter: drop-shadow(0 0 5px #ffffff);
        .calc-input__styled & {
          filter: drop-shadow(0 0 5px var(--selected-game-color));
        }
      }
    }
    svg path {
      .calc-input__styled & {
        fill: var(--selected-game-color);
      }
    }
    .calc-input__styled & {
      border-color: var(--selected-game-color);
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
</style>
